import { render, staticRenderFns } from "./nineJiuge.vue?vue&type=template&id=265726a8&scoped=true&"
import script from "./nineJiuge.vue?vue&type=script&lang=js&"
export * from "./nineJiuge.vue?vue&type=script&lang=js&"
import style0 from "./nineJiuge.vue?vue&type=style&index=0&id=265726a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265726a8",
  null
  
)

export default component.exports